import {
    Fragment,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import { OrderHistoryColumns } from "./OrderHistoryColumns";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../../env_config";
import Cookies from "js-cookie";
import {
    useExpanded,
    usePagination,
    useRowSelect,
    useSortBy,
    useTable,
} from "react-table";
import {
    FaAngleDoubleLeft,
    FaAngleDoubleRight,
    FaAngleLeft,
    FaAngleRight,
    FaChevronDown,
    FaChevronRight,
    FaMinus,
    FaPlus,
    FaSearch,
    FaSortDown,
    FaSortUp,
} from "react-icons/fa";
import { CheckBox } from "@material-ui/icons";
import { OrderHistoryExpandedDetails } from "./OrderHistoryExpandedDetails";
import { Button, Collapse } from "react-bootstrap";
import Select from "react-select";
import ApiDataSkeleton from "./ApiDataSkeleton";

export const OrderHistoryDetail = ({ userinfo, language }) => {
    const [data, setData] = useState([]);
    const timeoutRef = useRef(null);
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const [searchterms, setSearchTeams] = useState("");
    const [loadTable, setLoadTable] = useState(false);
    const [tablePageSize, setTablePageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [filterOptions, setFilterOptions] = useState({});
    useEffect(() => {
        const source = axios.CancelToken.source();

        setLoadTable(true);
        const handleapi = setTimeout(() => {
            axios
                .get(`${NODE_API_URL}/INTL/feed-order-history`, {
                    cancelToken: source.token,
                    params: {
                        page: pageIndex + 1,
                        limit: pageSize,
                        ...filterOptions,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get(
                            "cust_auth_token"
                        )}`,
                    },
                })
                .then((res) => {
                    if (res && res.data && res.data.data) {
                        setData(res.data.data);
                        setTotalCount(res.data.confirm_count);
                    }
                })
                .catch((error) => {
                    if (error?.response?.data?.message === "UnAuthorized!") {
                        var cookies = document.cookie.split(";");
                        for (var i = 0; i < cookies.length; i++) {
                            if (cookies[i] && !cookies[i].includes("view")) {
                                var equals = cookies[i].indexOf("=");
                                var name =
                                    equals > -1
                                        ? cookies[i].substr(0, equals)
                                        : cookies[i];
                                document.cookie =
                                    name +
                                    "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                            }
                        }

                        window.location.replace(`${BASE_URL}/logout`);
                    }
                })
                .finally(() => {
                    setLoadTable(false);
                });
        }, 500);

        return () => {
            source.cancel("Component unmounted, request cancelled");
            clearTimeout(handleapi);
        };
    }, [pageIndex, pageSize, filterOptions]);
    const renderRowSubComponent = useCallback(
        (row) => (
            <>
                <OrderHistoryExpandedDetails data={row.row.original} />
            </>
        ),
        [data]
    );

    const columns = useMemo(() => OrderHistoryColumns(language, userinfo, data), [
        language,
        userinfo,
        data
    ]);

    const {
        getTableProps,
        getTableBodyProps,
        prepareRow,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        pageCount,
        visibleColumns,
        setPageSize,
        state: { pageIndex, pageSize, selectedRowIds },
    } = useTable(
        {
            columns,
            data,
            manualPagination: true,
            initialState: { pageIndex: 0, pageSize: 10 },
            pageCount: Math.ceil(totalCount / tablePageSize),
            autoResetPage: false,
        },
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => {
                return [
                    {
                        id: "selection",
                        Cell: ({ row }) => (
                            <div>
                                {row.original.diamondStatus ===
                                    "Ready For Invoice" ||
                                row.original.diamondStatus ===
                                    "Ready To Ship" ||
                                row.original.diamondStatus === "QC Approved" ? (
                                    <CheckBox
                                        title="Select"
                                        {...row.getToggleRowSelectedProps()}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                        ),
                    },
                    {
                        Header: () => null,
                        id: "expander",
                        Cell: ({ row }) => (
                            <span {...row.getToggleRowExpandedProps()}>
                                {row.isExpanded ? (
                                    <FaChevronDown
                                        className="text-success "
                                        title="Collapse"
                                    />
                                ) : (
                                    <FaChevronRight
                                        className="text-primary"
                                        title="Expand"
                                    />
                                )}
                            </span>
                        ),
                    },
                    ...columns,
                ];
            });
        }
    );


    return (
        <div>
            <div className="card-body bg-white rounded pt-7 pb-0">
                <div className="card-toolbar d-flex justify-content-between align-items-center">
                    <div className="font-weight-bold font-size-lg">
                        {totalCount} Total Confirm Diamonds
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="input-group input-group-sm mr-2 mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text line-height-0 py-0">
                                    <FaSearch />
                                </span>
                            </div>
                            <input
                                className="form-control input-search"
                                value={searchterms || ""}
                                onChange={(e) => {
                                    setSearchTeams(e.target.value);
                                    const existingoptions = {
                                        ...filterOptions,
                                        searchterms: e.target.value,
                                    };

                                    if (timeoutRef.current) {
                                        clearTimeout(timeoutRef.current);
                                    }

                                    timeoutRef.current = setTimeout(() => {
                                        setFilterOptions(existingoptions);
                                    }, 1000);
                                }}
                            />
                        </div>
                    </div>
                </div>
                {loadTable ? (
                    <ApiDataSkeleton />
                ) : (
                    <div className="table-responsive w-100 mt-2">
                        <table
                            className="table table-hover"
                            {...getTableProps()}
                        >
                            <thead className="custom_datatable_head">
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th
                                                className="text-center align-middle"
                                                {...column.getHeaderProps(
                                                    column.getSortByToggleProps()
                                                )}
                                            >
                                                {column.render("Header")}
                                                <span className="text-secondary">
                                                    {column.isSorted ? (
                                                        column.isSortedDesc ? (
                                                            <FaSortDown />
                                                        ) : (
                                                            <FaSortUp />
                                                        )
                                                    ) : (
                                                        ""
                                                    )}
                                                </span>
                                            </th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {(data.length > 0 &&
                                    page.length > 0 &&
                                    page.map((row) => {
                                        prepareRow(row);
                                        const isSelected =
                                            selectedRowIds[row.id];
                                        return (
                                            <Fragment key={row.id}>
                                                <tr
                                                    {...row.getRowProps()}
                                                    key={row.id}
                                                    className={`${
                                                        isSelected
                                                            ? "bg-success-o-30"
                                                            : ""
                                                    }`}
                                                >
                                                    {row.cells.map(
                                                        (cell, i) => {
                                                            return (
                                                                <td
                                                                    className="text-center align-middle"
                                                                    {...cell.getCellProps(
                                                                        {
                                                                            className:
                                                                                cell
                                                                                    .column
                                                                                    .className,
                                                                        }
                                                                    )}
                                                                    key={i}
                                                                >
                                                                    {cell.render(
                                                                        "Cell"
                                                                    )}
                                                                </td>
                                                            );
                                                        }
                                                    )}
                                                </tr>
                                                {row.isExpanded ? (
                                                    <tr>
                                                        <td
                                                            className="p-0"
                                                            colSpan={
                                                                visibleColumns.length
                                                            }
                                                        >
                                                            {renderRowSubComponent(
                                                                {
                                                                    row,
                                                                }
                                                            )}
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </Fragment>
                                        );
                                    })) || (
                                    <tr>
                                        <td
                                            className="text-center bg-gray-200"
                                            colSpan="100%"
                                        >
                                            No records found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <div className="card-footer border-0">
                <div className="d-flex align-items-center justify-content-between">
                    <span className="table_page_length">
                        Page {pageIndex + 1} of {pageOptions.length}
                    </span>
                    <div>
                        <button
                            className="btn btn-sm btn-light mr-2"
                            onClick={() => gotoPage(0)}
                            disabled={!canPreviousPage}
                        >
                            <FaAngleDoubleLeft />
                        </button>
                        <button
                            className="btn btn-sm btn-light mr-2"
                            onClick={() => previousPage()}
                            disabled={!canPreviousPage}
                        >
                            <FaAngleLeft />
                        </button>
                        <span className="font-weight-bold text-muted">
                            <input
                                className="form-control d-inline-block form-control-sm"
                                type="number"
                                value={pageIndex + 1}
                                onChange={(e) => {
                                    const pageNumber = e.target.value
                                        ? Number(e.target.value) - 1
                                        : 0;
                                    gotoPage(pageNumber);
                                }}
                                style={{ maxWidth: "70px" }}
                            />
                            of {pageOptions.length}
                        </span>
                        <button
                            className="btn btn-sm btn-light mr-2"
                            onClick={() => nextPage()}
                            disabled={!canNextPage}
                        >
                            <FaAngleRight />
                        </button>
                        <button
                            className="btn btn-sm btn-light"
                            onClick={() => gotoPage(pageCount - 1)}
                            disabled={!canNextPage}
                        >
                            <FaAngleDoubleRight />
                        </button>
                    </div>
                    <span className="d-flex align-items-center">
                        <span className="text-nowrap page_size">
                            Rows Per page:
                        </span>
                        <select
                            className="form-select ml-2 custom-select py-1"
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                                setTablePageSize(Number(e.target.value));
                            }}
                        >
                            {[10, 25, 50].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                </option>
                            ))}
                        </select>
                    </span>
                </div>
            </div>
        </div>
    );
};
